import React from 'react';
import PropTypes from 'prop-types';

import {
    RIQPopover
} from '../RIQPopover.jsx';

import RIQSparkLine from '../RIQSparkLine.jsx';

MetricTableCell.Alignment = {
    LEFT: 'LEFT',
    RIGHT: 'RIGHT'
};

MetricTableCell.propTypes = {
    className: PropTypes.string,
    abbreviatedValue: PropTypes.node.isRequired,
    expandedValue: PropTypes.node,
    metricName: PropTypes.string,
    alignment: PropTypes.oneOf(_.keys(MetricTableCell.Alignment))
};

function Sparkline({data}) {
    // NOTE if we don't have data or the length is zero then nothing is
    // rendered, though there may be treatment necessary for such cases (to
    // indicate missing, incomplete data)
    if (!data || data.length === 0) {
        return null;
    }

    const sparklineData = _.map(data, (row, idx) => {
        return {
            id: idx,
            value: _.last(row)
        };
    });

    return <RIQSparkLine data={sparklineData}/>;
}

export default function MetricTableCell({className, abbreviatedValue, expandedValue, metricName, alignment, sparklineData}) {

    let headerWithPopover;
    if (expandedValue) {
        headerWithPopover = (
            <RIQPopover
                triggerNode={abbreviatedValue}
                placement='top'
                className={className}
                additionalHookProps={{
                    delayShow: RIQPopover.StandardDelayMS
                }}
            >
                <div className='tlw-px-7 tlw-py-4.5'>
                    <div
                        className='tlw-text-11 tlw-font-semibold tlw-uppercase tlw-text-gray-700'>
                        {metricName}
                    </div>
                    <div
                        className='tlw-text-xl tlw-font-bold tlw-leading-36 tlw-text-gray-900'>
                        {expandedValue}
                    </div>
                </div>
            </RIQPopover>
        );
    } else {
        headerWithPopover = <span className={className}>{abbreviatedValue}</span>;
    }

    const containerDivClasses = `tlw-flex tlw-flex-row tlw-items-center tlw-text-md tlw-font-normal tlw-text-gray-900 ${alignment === MetricTableCell.Alignment.LEFT ? 'tlw-justify-start tlw-mr-[35%]' : 'tlw-justify-end tlw-ml-[35%]'}`;
    return (
        <td
            className='tlw-max-w-0 tlw-p-4'>
            <div
                className={containerDivClasses}>
                <Sparkline data={sparklineData}/>
                {headerWithPopover}
            </div>
        </td>
    );
}
